import { Box, Card, Grid } from '@factorialco/deprecated-design-system'
import { endOfMonth, format } from 'date-fns'

import { useMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import BlankSlate from 'modules/insights/components/BlankSlate'
import type PromotionsByTeam from 'modules/insights/lib/metrics/promotionsByTeam'

import ApprovedPromotionsByTeamChart from './ApprovedPromotionsByTeamChart'
import MetricApprovedPromotions from './MetricApprovedPromotions'
import MetricRequestedPromotions from './MetricRequestedPromotions'

type Props = {
  promotionsByTeam: PromotionsByTeam
}

const WidgetApprovedPromotionsByTeam = ({ promotionsByTeam }: Props) => {
  const FORMAT_MONTH_YEAR = 'MMM yyyy'

  const currentMonth = useMemo(() => endOfMonth(new Date()), [])

  const {
    promotionsByStatus,
    approved,
    approvedLastMonth,
    totalRequestedThisMonth,
    totalRequestedLastMonth,
  } = promotionsByTeam.generate()

  return (
    <Card>
      <Card.Title tooltip={i18n.t('insights.widgets.approved_promotions.tooltip')}>
        {i18n.t('insights.widgets.approved_promotions.title')}
      </Card.Title>
      <Card.Description>{format(currentMonth, FORMAT_MONTH_YEAR)}</Card.Description>
      <Card.Content>
        {promotionsByTeam.isEmpty() ? (
          <BlankSlate />
        ) : (
          <Box maxHeight="s600">
            <Grid variant="fixed">
              <Box
                justifyContent="flexStart"
                gridColSpan={{ xxs: 8 }}
                gap="s48"
                flexDirection="row"
              >
                <MetricApprovedPromotions
                  approved={approved}
                  approvedLastMonth={approvedLastMonth}
                />
                <MetricRequestedPromotions
                  requested={totalRequestedThisMonth}
                  requestedLastMonth={totalRequestedLastMonth}
                />
              </Box>
              <Box gridColSpan={{ xxs: 12 }}>
                <ApprovedPromotionsByTeamChart promotionsByTeam={promotionsByStatus} />
              </Box>
            </Grid>
          </Box>
        )}
      </Card.Content>
    </Card>
  )
}

export default WidgetApprovedPromotionsByTeam
